import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KeyName} from 'src/app/app.keynames';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LoaderService } from 'src/app/_core/services';


@Component({
  selector: 'app-dialog-sync-active-plans',
  templateUrl: './dialog-sync-active-plans.component.html',
  styles: [`
    .required-fields {
      color: red !important
    }
  `
  ],
})
export class DialogSyncActivePlansComponent implements OnInit {
  listOfDetails = [
    {
      id: 'name',
      label: 'Name',
      value: false,
    },
    {
      id: 'category',
      label: 'Category',
      value: false,
    },
    {
      id: 'dimensions',
      label: 'Dimensions',
      value: false,
    },
    {
      id: 'freeShipping',
      label: 'Free Shipping',
      value: false,
    },
  ]

  listOfPricing = [
    {
      id: 'chargeModel',
      label: 'Charge Model',
      value: false,
    },
    {
      id: 'amount',
      label: 'Amount',
      value: false,
    },
    {
      id: 'quantity',
      label: 'Quantity',
      value: false,
    },
    {
      id: 'usePriceFromSaleChannel',
      label: 'Use Price & Qty from sale channel',
      value: false,
    },
    {
      id: 'allowChangeQuantity',
      label: 'Allow change quantity',
      value: false,
    },
  ]

  listOfSchedule = [
    {
      id: 'schedule',
      label: 'Schedule (as a whole, no sub-elements)',
      value: false,
    },
  ]

  listOfRules = [
    {
      id: 'rules',
      label: 'Rules (as a whole, no sub-elements)',
      value: false,
    },
  ]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<DialogSyncActivePlansComponent>,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _loader: LoaderService,
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
  }

  ngOnInit(): void {
       console.log('') /* 'Method not implemented.' */
    }

  onClose(): void {
    this._dialogRef.close();
  }

  onSubmit(): void {
    this._loader.startPageLoader();
    this._dialogRef.close({ code: KeyName.new_sync_active_plans, bodyParams: {
      details: this.listOfDetails.filter((item) => item.value),
      pricing: this.listOfPricing.filter((item) => item.value),
      schedule: this.listOfSchedule.filter((item) => item.value),
      rules: this.listOfRules.filter((item) => item.value)
    }});
  }

}
